import { Heart, Bookmark, Skull, Rocket } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const TYPES = [
  { key: "like", label: "Like", Icon: Heart, color: "#FF4D8D" },
  { key: "bookmarked", label: "Bookmarked", Icon: Bookmark, color: "#00F0FF" },
  { key: "terrifying", label: "Terrifying", Icon: Skull, color: "#FF5500" },
  { key: "must_visit", label: "Must Visit", Icon: Rocket, color: "#00FF66" },
];

export const Reactions = ({ planet, onChange, onNeedAuth }) => {
  const { user } = useAuth();

  const react = async (type) => {
    if (!user) return onNeedAuth ? onNeedAuth() : toast("Sign in to react to this world");
    try {
      const { data } = await api.post(`/planets/${planet.id}/reactions`, { type });
      onChange({ ...planet, reactions: data.reactions, my_reaction: data.my_reaction });
    } catch (e) {
      toast.error(errMsg(e));
    }
  };

  return (
    <div className="flex flex-wrap gap-2" data-testid="reactions-bar">
      {TYPES.map(({ key, label, Icon, color }) => {
        const active = planet.my_reaction === key;
        return (
          <button key={key} onClick={() => react(key)} data-testid={`reaction-${key}-button`}
            className="group inline-flex items-center gap-2 rounded-full border px-4 py-2 font-mono text-[0.65rem] uppercase tracking-[0.18em] transition-colors duration-200 active:scale-95"
            style={{
              borderColor: active ? color : "rgba(255,255,255,0.12)",
              background: active ? `${color}22` : "rgba(255,255,255,0.03)",
              color: active ? color : "#CBD5E1",
            }}>
            <Icon className="h-3.5 w-3.5 transition-transform duration-200 group-hover:scale-110" style={{ color }} />
            {label}
            <span className="font-semibold" data-testid={`reaction-${key}-count`}>{planet.reactions?.[key] ?? 0}</span>
          </button>
        );
      })}
    </div>
  );
};
